/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { UpdateDataSecondStageRequestMktuListInner } from './UpdateDataSecondStageRequestMktuListInner'
import {
  UpdateDataSecondStageRequestMktuListInnerFromJSON,
  UpdateDataSecondStageRequestMktuListInnerFromJSONTyped,
  UpdateDataSecondStageRequestMktuListInnerToJSON,
} from './UpdateDataSecondStageRequestMktuListInner'

/**
 *
 * @export
 * @interface UpdateDataSecondStageRequest
 */
export interface UpdateDataSecondStageRequest {
  /**
   * Выбранные классы МКТУ
   * @type {Array<UpdateDataSecondStageRequestMktuListInner>}
   * @memberof UpdateDataSecondStageRequest
   */
  mktuList: Array<UpdateDataSecondStageRequestMktuListInner>
}

/**
 * Check if a given object implements the UpdateDataSecondStageRequest interface.
 */
export function instanceOfUpdateDataSecondStageRequest(
  value: object
): value is UpdateDataSecondStageRequest {
  if (!('mktuList' in value) || value['mktuList'] === undefined) return false
  return true
}

export function UpdateDataSecondStageRequestFromJSON(
  json: any
): UpdateDataSecondStageRequest {
  return UpdateDataSecondStageRequestFromJSONTyped(json, false)
}

export function UpdateDataSecondStageRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateDataSecondStageRequest {
  if (json == null) {
    return json
  }
  return {
    mktuList: (json['mktuList'] as Array<any>).map(
      UpdateDataSecondStageRequestMktuListInnerFromJSON
    ),
  }
}

export function UpdateDataSecondStageRequestToJSON(
  value?: UpdateDataSecondStageRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    mktuList: (value['mktuList'] as Array<any>).map(
      UpdateDataSecondStageRequestMktuListInnerToJSON
    ),
  }
}
